import { RuleCreatorHeaderCell } from './RuleCreatorHeaderCell';
import { Rule } from '../../lib/Rule';

export const ruleCreatorColumn = {
  dataIndex: Rule.CREATOR,
  title: <RuleCreatorHeaderCell />,
};
